import React from 'react';

// Dashed connector linking sequential items (steps, reasons, stats) instead
// of leaving them as isolated cards. Reuses the .route-line-path marching-ants
// keyframe already defined in index.css (paused under prefers-reduced-motion).
function ConnectorLine({ orientation = 'horizontal', className = '' }) {
  const isVertical = orientation === 'vertical';

  return (
    <svg
      className={`connector-line connector-line-${orientation} ${className}`.trim()}
      viewBox={isVertical ? '0 0 4 200' : '0 0 200 4'}
      preserveAspectRatio="none"
      width={isVertical ? 4 : '100%'}
      height={isVertical ? '100%' : 4}
      aria-hidden="true"
    >
      <line
        className="route-line-path"
        x1={isVertical ? 2 : 0}
        y1={isVertical ? 0 : 2}
        x2={isVertical ? 2 : 200}
        y2={isVertical ? 200 : 2}
        stroke="var(--accent)"
        strokeWidth="3"
        strokeLinecap="round"
        strokeDasharray="10 12"
      />
    </svg>
  );
}

export default ConnectorLine;
